// This import loads the firebase namespace along with all its type information.
import Category from './category-model'

export async function load_categorys(): Promise<Category[]> {
  throw 'Not implemented'
}

export async function delete_category(): Promise<boolean> {
  throw 'Not implemented'
}

export async function store_category(): Promise<Category> {
  throw 'Not implemented'
}
